import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	fetchError: {
		id: `eoc.responder-names-fetch-error`,
		defaultMessage: "We couldn't fetch the responder names.",
		description: 'The text will be displayed when there is error',
	},
	retry: {
		id: `eoc.responder-names-retry`,
		defaultMessage: 'Retry',
		description: 'The title for retry as a single word.',
	},
});
